/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import type {
  BadRequestResponse,
  ForbiddenResponse,
  GetPlatformMessagesInfoParams,
  GetPlattformMessagesParams,
  GetStalledPlatformMessagesParams,
  InternalServerErrorResponse,
  MessageCreateSuccessDTO,
  MessageResendSuccessDTO,
  PaginatedPlatformMessageListItemsDTO,
  PaginatedPlatformMessageStalledMessagesListItemsDTO,
  PlatformMessageDTO,
  PlatformMessagesInfoDTO,
  TooManyRequestsResponse,
  UnauthorizedResponse,
} from "../../model";
import { customFetchInstance } from "../../../custom-fetch-instance";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Returns all messages
 * @summary Returns a paginated List of all messages
 */
export type getPlattformMessagesResponse = {
  data: PaginatedPlatformMessageListItemsDTO;
  status: number;
};

export const getGetPlattformMessagesUrl = (
  params?: GetPlattformMessagesParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `http://localhost:8080/platform/v1/messages?${normalizedParams.toString()}`
    : `http://localhost:8080/platform/v1/messages`;
};

export const getPlattformMessages = async (
  params?: GetPlattformMessagesParams,
  options?: RequestInit
): Promise<getPlattformMessagesResponse> => {
  return customFetchInstance<Promise<getPlattformMessagesResponse>>(
    getGetPlattformMessagesUrl(params),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetPlattformMessagesQueryKey = (
  params?: GetPlattformMessagesParams
) => {
  return [
    `http://localhost:8080/platform/v1/messages`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPlattformMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlattformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params?: GetPlattformMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlattformMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlattformMessagesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlattformMessages>>
  > = ({ signal }) =>
    getPlattformMessages(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlattformMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlattformMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlattformMessages>>
>;
export type GetPlattformMessagesQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

export function useGetPlattformMessages<
  TData = Awaited<ReturnType<typeof getPlattformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: undefined | GetPlattformMessagesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlattformMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlattformMessages>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlattformMessages<
  TData = Awaited<ReturnType<typeof getPlattformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params?: GetPlattformMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlattformMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlattformMessages>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlattformMessages<
  TData = Awaited<ReturnType<typeof getPlattformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params?: GetPlattformMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlattformMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a paginated List of all messages
 */

export function useGetPlattformMessages<
  TData = Awaited<ReturnType<typeof getPlattformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params?: GetPlattformMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlattformMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlattformMessagesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPlattformMessagesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlattformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params?: GetPlattformMessagesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlattformMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlattformMessagesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlattformMessages>>
  > = ({ signal }) =>
    getPlattformMessages(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPlattformMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlattformMessagesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlattformMessages>>
>;
export type GetPlattformMessagesSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

export function useGetPlattformMessagesSuspense<
  TData = Awaited<ReturnType<typeof getPlattformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: undefined | GetPlattformMessagesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlattformMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlattformMessagesSuspense<
  TData = Awaited<ReturnType<typeof getPlattformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params?: GetPlattformMessagesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlattformMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlattformMessagesSuspense<
  TData = Awaited<ReturnType<typeof getPlattformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params?: GetPlattformMessagesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlattformMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a paginated List of all messages
 */

export function useGetPlattformMessagesSuspense<
  TData = Awaited<ReturnType<typeof getPlattformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params?: GetPlattformMessagesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlattformMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlattformMessagesSuspenseQueryOptions(
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a specific message detail  id
 * @summary Returns a specific message
 */
export type getPlatformMessageByIdResponse = {
  data: PlatformMessageDTO;
  status: number;
};

export const getGetPlatformMessageByIdUrl = (messageId: string) => {
  return `http://localhost:8080/platform/v1/messages/${messageId}`;
};

export const getPlatformMessageById = async (
  messageId: string,
  options?: RequestInit
): Promise<getPlatformMessageByIdResponse> => {
  return customFetchInstance<Promise<getPlatformMessageByIdResponse>>(
    getGetPlatformMessageByIdUrl(messageId),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetPlatformMessageByIdQueryKey = (messageId: string) => {
  return [`http://localhost:8080/platform/v1/messages/${messageId}`] as const;
};

export const getGetPlatformMessageByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformMessageById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessageById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlatformMessageByIdQueryKey(messageId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformMessageById>>
  > = ({ signal }) =>
    getPlatformMessageById(messageId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!messageId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformMessageById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformMessageByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformMessageById>>
>;
export type GetPlatformMessageByIdQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

export function useGetPlatformMessageById<
  TData = Awaited<ReturnType<typeof getPlatformMessageById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  messageId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessageById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformMessageById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformMessageById<
  TData = Awaited<ReturnType<typeof getPlatformMessageById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessageById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformMessageById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformMessageById<
  TData = Awaited<ReturnType<typeof getPlatformMessageById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessageById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a specific message
 */

export function useGetPlatformMessageById<
  TData = Awaited<ReturnType<typeof getPlatformMessageById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessageById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlatformMessageByIdQueryOptions(
    messageId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPlatformMessageByIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformMessageById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessageById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlatformMessageByIdQueryKey(messageId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformMessageById>>
  > = ({ signal }) =>
    getPlatformMessageById(messageId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!messageId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPlatformMessageById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformMessageByIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformMessageById>>
>;
export type GetPlatformMessageByIdSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

export function useGetPlatformMessageByIdSuspense<
  TData = Awaited<ReturnType<typeof getPlatformMessageById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  messageId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessageById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformMessageByIdSuspense<
  TData = Awaited<ReturnType<typeof getPlatformMessageById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessageById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformMessageByIdSuspense<
  TData = Awaited<ReturnType<typeof getPlatformMessageById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessageById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a specific message
 */

export function useGetPlatformMessageByIdSuspense<
  TData = Awaited<ReturnType<typeof getPlatformMessageById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  messageId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessageById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlatformMessageByIdSuspenseQueryOptions(
    messageId,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns an aggregated overview of the requesting user's messages in the chosen time range
 * @summary Returns an aggregated overview of my messages
 */
export type getPlatformMessagesInfoResponse = {
  data: PlatformMessagesInfoDTO;
  status: number;
};

export const getGetPlatformMessagesInfoUrl = (
  params: GetPlatformMessagesInfoParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `http://localhost:8080/platform/v1/messages/info?${normalizedParams.toString()}`
    : `http://localhost:8080/platform/v1/messages/info`;
};

export const getPlatformMessagesInfo = async (
  params: GetPlatformMessagesInfoParams,
  options?: RequestInit
): Promise<getPlatformMessagesInfoResponse> => {
  return customFetchInstance<Promise<getPlatformMessagesInfoResponse>>(
    getGetPlatformMessagesInfoUrl(params),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetPlatformMessagesInfoQueryKey = (
  params: GetPlatformMessagesInfoParams
) => {
  return [
    `http://localhost:8080/platform/v1/messages/info`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPlatformMessagesInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetPlatformMessagesInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlatformMessagesInfoQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformMessagesInfo>>
  > = ({ signal }) =>
    getPlatformMessagesInfo(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformMessagesInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformMessagesInfo>>
>;
export type GetPlatformMessagesInfoQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

export function useGetPlatformMessagesInfo<
  TData = Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetPlatformMessagesInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformMessagesInfo<
  TData = Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetPlatformMessagesInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformMessagesInfo<
  TData = Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetPlatformMessagesInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns an aggregated overview of my messages
 */

export function useGetPlatformMessagesInfo<
  TData = Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetPlatformMessagesInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlatformMessagesInfoQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPlatformMessagesInfoSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetPlatformMessagesInfoParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlatformMessagesInfoQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformMessagesInfo>>
  > = ({ signal }) =>
    getPlatformMessagesInfo(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformMessagesInfoSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformMessagesInfo>>
>;
export type GetPlatformMessagesInfoSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

export function useGetPlatformMessagesInfoSuspense<
  TData = Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetPlatformMessagesInfoParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformMessagesInfoSuspense<
  TData = Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetPlatformMessagesInfoParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformMessagesInfoSuspense<
  TData = Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetPlatformMessagesInfoParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns an aggregated overview of my messages
 */

export function useGetPlatformMessagesInfoSuspense<
  TData = Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetPlatformMessagesInfoParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformMessagesInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlatformMessagesInfoSuspenseQueryOptions(
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Triggers a test message to the calling users organisation
 * @summary Send test message
 */
export type createPlatformMessageTestMessageResponse = {
  data: MessageCreateSuccessDTO;
  status: number;
};

export const getCreatePlatformMessageTestMessageUrl = () => {
  return `http://localhost:8080/platform/v1/messages/test`;
};

export const createPlatformMessageTestMessage = async (
  options?: RequestInit
): Promise<createPlatformMessageTestMessageResponse> => {
  return customFetchInstance<Promise<createPlatformMessageTestMessageResponse>>(
    getCreatePlatformMessageTestMessageUrl(),
    {
      ...options,
      method: "POST",
    }
  );
};

export const getCreatePlatformMessageTestMessageMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPlatformMessageTestMessage>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPlatformMessageTestMessage>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPlatformMessageTestMessage>>,
    void
  > = () => {
    return createPlatformMessageTestMessage(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePlatformMessageTestMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPlatformMessageTestMessage>>
>;

export type CreatePlatformMessageTestMessageMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

/**
 * @summary Send test message
 */
export const useCreatePlatformMessageTestMessage = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPlatformMessageTestMessage>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPlatformMessageTestMessage>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getCreatePlatformMessageTestMessageMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * When called all stalled messages of the user's organisation will be rescheduled.
 * @summary Resend all stalled messages
 */
export type resendStalledMessagesResponse = {
  data: MessageResendSuccessDTO;
  status: number;
};

export const getResendStalledMessagesUrl = () => {
  return `http://localhost:8080/platform/v1/messages/resend`;
};

export const resendStalledMessages = async (
  options?: RequestInit
): Promise<resendStalledMessagesResponse> => {
  return customFetchInstance<Promise<resendStalledMessagesResponse>>(
    getResendStalledMessagesUrl(),
    {
      ...options,
      method: "POST",
    }
  );
};

export const getResendStalledMessagesMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendStalledMessages>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendStalledMessages>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendStalledMessages>>,
    void
  > = () => {
    return resendStalledMessages(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendStalledMessagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendStalledMessages>>
>;

export type ResendStalledMessagesMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

/**
 * @summary Resend all stalled messages
 */
export const useResendStalledMessages = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendStalledMessages>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resendStalledMessages>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getResendStalledMessagesMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Returns a paginated list of the requesting user's stalled messages
 * @summary Returns all of the user's stalled messages
 */
export type getStalledPlatformMessagesResponse = {
  data: PaginatedPlatformMessageStalledMessagesListItemsDTO;
  status: number;
};

export const getGetStalledPlatformMessagesUrl = (
  params: GetStalledPlatformMessagesParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `http://localhost:8080/platform/v1/messages/stalled?${normalizedParams.toString()}`
    : `http://localhost:8080/platform/v1/messages/stalled`;
};

export const getStalledPlatformMessages = async (
  params: GetStalledPlatformMessagesParams,
  options?: RequestInit
): Promise<getStalledPlatformMessagesResponse> => {
  return customFetchInstance<Promise<getStalledPlatformMessagesResponse>>(
    getGetStalledPlatformMessagesUrl(params),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetStalledPlatformMessagesQueryKey = (
  params: GetStalledPlatformMessagesParams
) => {
  return [
    `http://localhost:8080/platform/v1/messages/stalled`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetStalledPlatformMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getStalledPlatformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetStalledPlatformMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStalledPlatformMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStalledPlatformMessagesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStalledPlatformMessages>>
  > = ({ signal }) =>
    getStalledPlatformMessages(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStalledPlatformMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStalledPlatformMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStalledPlatformMessages>>
>;
export type GetStalledPlatformMessagesQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

export function useGetStalledPlatformMessages<
  TData = Awaited<ReturnType<typeof getStalledPlatformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetStalledPlatformMessagesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStalledPlatformMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStalledPlatformMessages>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetStalledPlatformMessages<
  TData = Awaited<ReturnType<typeof getStalledPlatformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetStalledPlatformMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStalledPlatformMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStalledPlatformMessages>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetStalledPlatformMessages<
  TData = Awaited<ReturnType<typeof getStalledPlatformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetStalledPlatformMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStalledPlatformMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns all of the user's stalled messages
 */

export function useGetStalledPlatformMessages<
  TData = Awaited<ReturnType<typeof getStalledPlatformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetStalledPlatformMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStalledPlatformMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStalledPlatformMessagesQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetStalledPlatformMessagesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getStalledPlatformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetStalledPlatformMessagesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getStalledPlatformMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStalledPlatformMessagesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStalledPlatformMessages>>
  > = ({ signal }) =>
    getStalledPlatformMessages(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getStalledPlatformMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStalledPlatformMessagesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStalledPlatformMessages>>
>;
export type GetStalledPlatformMessagesSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

export function useGetStalledPlatformMessagesSuspense<
  TData = Awaited<ReturnType<typeof getStalledPlatformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetStalledPlatformMessagesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getStalledPlatformMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetStalledPlatformMessagesSuspense<
  TData = Awaited<ReturnType<typeof getStalledPlatformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetStalledPlatformMessagesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getStalledPlatformMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetStalledPlatformMessagesSuspense<
  TData = Awaited<ReturnType<typeof getStalledPlatformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetStalledPlatformMessagesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getStalledPlatformMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns all of the user's stalled messages
 */

export function useGetStalledPlatformMessagesSuspense<
  TData = Awaited<ReturnType<typeof getStalledPlatformMessages>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  params: GetStalledPlatformMessagesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getStalledPlatformMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStalledPlatformMessagesSuspenseQueryOptions(
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
